import { render } from "./Mpesa_Authentication.vue?vue&type=template&id=2f125259"
import script from "./Mpesa_Authentication.vue?vue&type=script&lang=js"
export * from "./Mpesa_Authentication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__